// src/pages/.../ManageMembers/hooks/useMembersFilters.js

import { useMemo, useState } from "react";

import {
  getAdherentGroups,
  getGroupDojoId,
} from "../utils/manageMembers.utils";

export default function useMembersFilters({
  adherents,
  groups,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDojo, setSelectedDojo] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");

  const filteredGroups = useMemo(() => {
    const safeGroups = Array.isArray(groups) ? groups : [];

    if (!selectedDojo) {
      return safeGroups;
    }

    return safeGroups.filter(
      (group) =>
        String(getGroupDojoId(group)) ===
        String(selectedDojo),
    );
  }, [groups, selectedDojo]);

  const filteredAdherents = useMemo(() => {
    const normalizedSearch = searchTerm
      .trim()
      .toLowerCase();

    return (Array.isArray(adherents) ? adherents : []).filter(
      (adherent) => {
        const searchableContent = [
          adherent?.nom,
          adherent?.prenom,
          adherent?.email,
          adherent?.tel,
          adherent?.commune,
          adherent?.licence_number,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        const matchesSearch =
          !normalizedSearch ||
          searchableContent.includes(normalizedSearch);

        const adherentGroups = getAdherentGroups(adherent);

        const matchesDojo =
          !selectedDojo ||
          adherentGroups.some(
            (group) =>
              String(getGroupDojoId(group)) ===
              String(selectedDojo),
          );

        const matchesGroup =
          !selectedGroup ||
          adherentGroups.some(
            (group) =>
              String(group?.id) ===
              String(selectedGroup),
          );

        return (
          matchesSearch &&
          matchesDojo &&
          matchesGroup
        );
      },
    );
  }, [
    adherents,
    searchTerm,
    selectedDojo,
    selectedGroup,
  ]);

  const handleDojoChange = (dojoId) => {
    setSelectedDojo(dojoId);
    setSelectedGroup("");
  };

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedDojo("");
    setSelectedGroup("");
  };

  return {
    searchTerm,
    selectedDojo,
    selectedGroup,

    filteredGroups,
    filteredAdherents,

    setSearchTerm,
    setSelectedGroup,
    handleDojoChange,
    resetFilters,
  };
}